module.exports = __webpack_public_path__ + "profil_active.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/profil_active.svg
// module id = 120
// module chunks = 0